import { gsap } from "gsap";

const STORAGE_KEY = "vantage_preloader_shown";
const preloader = document.querySelector(".preloader");

function finishPreloader() {
    if (preloader) {
        preloader.classList.add("hidden");
    }

    const pagination = document.querySelector(".slider__pagination");
    if (pagination) {
        pagination.classList.add("active");
    }

    document.querySelectorAll(".main-slider_img").forEach((slide) => {
        slide.classList.add("active");
    });
    document.querySelectorAll(".main-slider_title-wrap").forEach((slide) => {
        slide.classList.add("active");
    });
    document.querySelectorAll(".main-slider_img-wrap").forEach((slide) => {
        slide.classList.add("active");
    });

    document.documentElement.classList.add("preloader-finished");
}

function markPreloaderShown() {
    try {
        sessionStorage.setItem(STORAGE_KEY, "1");
    } catch (e) {}
}

function wasPreloaderShown() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
        return false;
    }
}

// Already seen this session — skip animation, show content immediately
if (wasPreloaderShown() || document.documentElement.classList.contains("preloader-skipped")) {
    finishPreloader();
} else {
    const images = gsap.utils.toArray(".preloader__image");
    const tl = gsap.timeline();

    images.forEach((image, index) => {
        image.style.zIndex = index + 1;
    });

    tl.addLabel("start");

    images.forEach((image, index) => {
        tl.to(
            image,
            {
                opacity: 1,
                duration: 0.05,
                ease: "power1.inOut",
            },
            `start+=${(index + 1) * 0.2}`
        );
    });

    images.forEach((image, index) => {
        tl.fromTo(
            image,
            {
                scale: 0.4 - index * 0.04,
                rotation: 0.01,
            },
            {
                scale: 0.6 - index * 0.04,
                rotation: 0.01,
                duration: 2,
                ease: "power3.out",
                force3D: true,
            },
            `start+=${index * 0.03}`
        );

        tl.to(
            image.querySelector("img"),
            {
                scale: 1.4,
                duration: 2,
                ease: "power3.out",
                force3D: true,
            },
            `start+=${index * 0.03}`
        );

        if (index < images.length - 1) {
            tl.to(
                image,
                {
                    scale: 0.6 - (images.length - 1) * 0.05,
                    duration: 0.6,
                    ease: "power1.inOut",
                },
                index === 0 ? null : "-=0.6"
            );
        }
    });

    const lastImage = images[images.length - 1];

    tl.to(
        lastImage,
        {
            scale: 1,
            duration: 1.4,
            ease: "power4.inOut",
        },
        "-=0.55"
    );

    tl.to(
        lastImage.querySelector("img"),
        {
            scale: 1,
            duration: 1.4,
            ease: "power4.inOut",
        },
        "<"
    );

    tl.call(() => {
        markPreloaderShown();
        finishPreloader();
    });
}
